export default "__VITE_ASSET__CzdvR7B2__"